export const SubmitLocalStorageSearch = (searchBar) => {
  if (searchBar.value !== "") {
    const listSearch = localStorage.getItem("listSearch");
    const objectSearch = {
      id: searchBar.value,
      label: searchBar.value,
    };
    if (listSearch) {
      const parseListSearch = JSON.parse(listSearch);
      const filterExists = parseListSearch.find(
        (search) => search.label === objectSearch.label
      );
      if (!filterExists) {
        parseListSearch.push(objectSearch);
      }
      localStorage.setItem("listSearch", JSON.stringify(parseListSearch));
    } else {
      localStorage.setItem("listSearch", JSON.stringify([objectSearch]));
    }
  }
};

export const DeleteLocalStorageSearch = (value) => {
  const listSearch = localStorage.getItem("listSearch");
  const parseListSearch = JSON.parse(listSearch);
  const filterSearch = parseListSearch.filter(
    (search) => search.label !== value
  );
  localStorage.setItem("listSearch", JSON.stringify(filterSearch));
  return filterSearch;
};
